import { styled } from '../../theme'
import { MsdkStyledComponent } from '../../utils'
import { Box } from '../Box'

export const Footer: MsdkStyledComponent<any> = styled(Box)``
